module.exports = __webpack_public_path__ + "static/media/age-verif.90b2b5ea.svg";